import { default as androidApplications } from "./androidApplications.json";
import { default as application10001 } from "./application-10001.json";
import { default as application10002 } from "./application-10002.json";
import { default as application10003 } from "./application-10003.json";
import { default as application10010 } from "./application-10010.json";
import { default as applicationsError } from "./application-error.json";
import { default as applicationsList } from "./applications.json";
import { default as iOSApplications } from "./iOSApplications.json";

const data: { [key: string]: any } = {
  application: {
    10001: application10001,
    10002: application10002,
    10003: application10003,
    10010: application10010,
  },
  applications: applicationsList,
  error: applicationsError,
  iOSApplications: iOSApplications,
  androidApplications: androidApplications,
};

const applications = {
  connect: (applicationId: string) => {
    const application = data.application[applicationId];
    if (!application) {
      console.warn("An invalid applicationId was provided:", applicationId);
    }

    application.data.attributes.connected = true;
    return application;
  },
  disconnect: (applicationId: string) => {
    const application = data.application[applicationId];
    if (!application) {
      console.warn("An invalid applicationId was provided:", applicationId);
    }

    application.data.attributes.connected = false;
    return application;
  },
  get: (platform: string | null) => {
    if (platform === "ios") {
      return data.iOSApplications;
    } else if (platform === "android") {
      return data.androidApplications;
    }

    return data.applications;
  },
  getById: (applicationId: string) => data.application[applicationId],
};

export default applications;
